


























import Vue from 'vue'
import { FetchAllProceduresCommand, ProcedureDto } from '@/Application/Procedures'
import { PaginatedResultDto } from '@/Application/Pagination/PaginatedResultDto'
import {
  FetchAllProceduresCommandHandlerProvider
} from '@/Infrastructure/Procedures/Provider/FetchAllProceduresCommandHandlerProvider'
import ProcedureRow from '@/UI/Procedures/ProcedureRow.vue'
import ProceduresTableHeader from '@/UI/Procedures/ProceduresTableHeader.vue'
import ProceduresListSearch from '@/UI/Procedures/ProceduresListSearch.vue'
import { EventBus } from '@/Infrastructure/EventBus/EventBus'
import Paginator from '@/UI/Shared/Paginator/Paginator.vue'
import { ProcedureFilters } from '@/Domain/Procedures/RepositoryModifiers/ProcedureFilters'

export default Vue.extend({
  name: 'ProceduresList',
  components: { Paginator, ProceduresListSearch, ProcedureRow, ProceduresTableHeader },
  data () {
    return {
      proceduresList: [] as ProcedureDto[],
      currentPage: 1,
      totalPages: 1,
      itemsPerPage: 10,
      totalProcedures: 0,
      filters: {
        code: '',
        procedureType: '',
        province: '',
        dateTo: '',
        dateFrom: ''
      }
    }
  },
  mounted () {
    this.loadProcedures()
  },
  methods: {
    loadProcedures () {
      EventBus.$emit('loading', true)
      const command = new FetchAllProceduresCommand(
        { page: this.currentPage, itemsPerPage: this.itemsPerPage },
        this.filters
      )
      const provider = new FetchAllProceduresCommandHandlerProvider()
      const handler = provider.provide()
      handler.handle(command)
        .then((response: PaginatedResultDto<ProcedureDto>) => {
          this.proceduresList = response.items
          this.currentPage = response.currentPage
          this.totalPages = response.totalPages
          this.totalProcedures = response.totalItemCount
        })
        .finally(() => {
          EventBus.$emit('loading', false)
        })
    },
    onPageChanged (newPage: number) {
      this.currentPage = newPage
      this.loadProcedures()
    },
    onFiltersUpdated ($event: ProcedureFilters) {
      const lastFilters = { ...this.filters }
      this.filters.code = $event.code || ''
      this.filters.procedureType = $event.procedureType || ''
      this.filters.province = $event.province || ''
      this.filters.dateFrom = $event.dateFrom || ''
      this.filters.dateTo = $event.dateTo || ''
      if (JSON.stringify(this.filters) !== JSON.stringify(lastFilters)) {
        this.currentPage = 1
        this.loadProcedures()
      }
    }
  }
})
